import React from 'react';
import { Star, Quote } from 'lucide-react';
const TESTIMONIALS = [{
  quote: 'Linda was thorough, responsive and knowledgeable, making the entire process smooth and stress free.',
  name: 'Sarah & Michael',
  location: 'Australia'
}, {
  quote: 'Fast, efficient and PERSONAL! They do not treat you like another transaction.',
  name: 'Mitchell',
  location: 'Australia'
}];
export function Proof() {
  return <section className="py-10 md:py-14 px-5 md:px-6 bg-cream" data-id="element-311" data-mp="2tewiivygayuq">
      <div className="max-w-7xl mx-auto" data-id="element-312" data-mp="2ogmkmdlcdk5f">
        <div className="flex flex-col md:flex-row md:items-end justify-between gap-4 mb-6 md:mb-8" data-id="element-313" data-mp="2ojqv1spehc4j">
          <div data-id="element-314" data-mp="33cud016wlrvs">
            <p className="eyebrow text-brand-blue mb-1" data-id="element-315" data-mp="2yfu83tlsiv69">
              in their words
            </p>
            <h2 className="text-3xl md:text-[2.6rem] leading-tight text-ink" data-id="element-316" data-mp="190w2lvwuypyb">
              What clients value.
            </h2>
            <div className="mt-4 flex items-center gap-3" data-id="element-317" data-mp="142ksrl6kcfg3">
              <div className="flex text-accent" data-id="element-318" data-mp="1445nbasvnydy">
                {[...Array(5)].map((_, i) => <Star key={i} className="w-5 h-5" fill="currentColor" data-id="element-319" data-mp="2delat9uski6" data-mpi={i} />)}
              </div>
              <span className="font-semibold text-ink" data-id="element-320" data-mp="bg5x4u6n5iac">5.0 Google rating</span>
              <span className="text-muted-ink" data-id="element-321" data-mp="be2wzhbry8rw">·</span>
              <span className="text-muted-ink" data-id="element-322" data-mp="g7nw5cp3t8so">10 reviews</span>
            </div>
          </div>

          <a href="https://www.google.com/maps" target="_blank" rel="noopener noreferrer" className="inline-flex items-center gap-1.5 font-semibold text-brand-blue hover:text-brand-blue-dark transition-colors" data-id="element-323" data-mp="l4nut2jmj99r">
            Read Google reviews
          </a>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-4" data-id="element-324" data-mp="z4p3h464rkzs">
          {TESTIMONIALS.map(t => <figure key={t.name} className="relative flex h-full flex-col border-t-2 border-peach bg-surface p-6" data-id="element-325" data-mp="2vzv19x3yubcb">
              <Quote className="w-9 h-9 text-accent/25 mb-4" fill="currentColor" data-id="element-326" data-mp="81lbm69d2dpn" />
              <blockquote className="font-serif text-xl md:text-2xl text-ink leading-snug" data-id="element-327" data-mp="34uwpm9alo5t">
                {t.quote}
              </blockquote>
              <figcaption className="mt-auto pt-5 flex items-center gap-3" data-id="element-328" data-mp="c482o4y7juls">
                <span className="inline-flex w-10 h-10 items-center justify-center rounded-full bg-accent-soft text-accent font-serif text-lg" data-id="element-329" data-mp="c6b55ogjrg7e">
                  {t.name.charAt(0)}
                </span>
                <span data-id="element-330" data-mp="m0bek2iv37lx">
                  <span className="block font-semibold text-ink" data-id="element-331" data-mp="zu2gopu9jp7m">{t.name}</span>
                  <span className="block text-sm text-muted-ink" data-id="element-332" data-mp="vrxnfs7q8uli">
                    {t.location}
                  </span>
                </span>
              </figcaption>
            </figure>)}
        </div>

        <p className="mt-5 text-xs text-muted-ink" data-id="element-333" data-mp="14t5mici2hzgn">
          Client feedback published on the existing website.
        </p>
      </div>
    </section>;
}